module.exports = "<p>\n  time-roll-san-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Attendance-Leaves/time-roll-sanctions/time-roll-san-form/time-roll-san-form.component.html
// module id = ./src/app/hrms/Attendance-Leaves/time-roll-sanctions/time-roll-san-form/time-roll-san-form.component.html
// module chunks = main